import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AttributeSection from "./components/AttributeSection";
import VariantSection from "./components/VariantSection";
import Select from "components/ui/Select";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategoriesService,
  getSubCategorieByCategoryService,
} from "redux/services/categories_service";
import ProductImageUpload from "./components/ProductImageUpload";
import Button from "components/ui/Button"; // تأكد من استيراد الزر من المسار الصحيح
import {
  createProductService,
  getAllProductsService,
} from "redux/services/products_sevice";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const AddProduct = ({ setIsAddProduct }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoadingAction } = useSelector((state) => state.products);
  const { categoryList, subCategories } = useSelector(
    (state) => state.categories,
  );
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    category_ids: [],
    subcategory_id:[],
    price: "",
    price_after_discount: "",
    is_special: false,
    images: [],
    translations: {
      //  en: { name: "", desc: "" },
      ar: { name: "", desc: "" },
    },
    attributes: [],
    variants: [],
    hasAttributes: true, // جديد: افتراضي true
    quantity: "",
  });

  const handleInputChange = (field, value) => {
    if (field.includes("translations")) {
      const [lang, key] = field.split(".").slice(1);
      setFormData((prev) => ({
        ...prev,
        translations: {
          ...prev.translations,
          [lang]: { ...prev.translations[lang], [key]: value },
        },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
  };

  const handleSelectChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAddAttribute = (attribute) => {
    setFormData((prev) => ({
      ...prev,
      attributes: [...prev.attributes, attribute],
    }));
  };

  const handleAddVariant = (variant) => {
    setFormData((prev) => ({
      ...prev,
      variants: [...prev.variants, variant],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    console.log(formData);
    console.log("formData?.images");
    console.log(formData?.images);

    try {
      const formData2 = new FormData();

      // Append basic product data
      //  formData2.append("category_id", formData.subcategory_id);
      formData.category_ids.forEach((id, index) => {
        formData2.append(`category_ids[${index + 1}]`, id);
      });
      formData.subcategory_id.forEach((id, index) => {
        formData2.append(`category_ids[${index + 1}]`, id);
      });
      formData2.append("price", formData.price);
      formData2.append("price_after_discount", formData.price_after_discount);
      formData2.append("is_special", formData.is_special ? "1" : "0");
      !formData.hasAttributes &&
        formData2.append("quantity", parseInt(formData.quantity, 10));

      // Append translations
      Object.keys(formData?.translations).forEach((lang) => {
        Object.keys(formData.translations[lang]).forEach((key) => {
          formData2.append(
            `translations[${lang}][${key}]`,
            formData.translations[lang][key],
          );
        });
      });

      // Process IMAGE
      formData?.images?.forEach((im, index) => {
        formData2.append(`images[${index + 1}]`, im?.file);
      });

      // Process attributes
      formData.hasAttributes &&
        formData?.attributes?.forEach((attr, index) => {
          /*  formData2.append(
          `attributes[${index + 1}][translations][en][name]`,
          attr.name.en
        );*/
          formData2.append(
            `attributes[${index + 1}][translations][ar][name]`,
            attr.name.ar,
          );

          attr?.values?.forEach((val, valIndex) => {
            if (val) {
              /* formData2.append(
              `attributes[${index + 1}][values][${
                valIndex + 1
              }][translations][en][value]`,
              val.en
            );*/
              formData2.append(
                `attributes[${index + 1}][values][${
                  valIndex + 1
                }][translations][ar][value]`,
                val.ar,
              );
            }
          });
        });

      // Process variants
      formData.hasAttributes &&
        formData.variants.forEach((variant, index) => {
          formData2.append(
            `variants[${index + 1}][quantity]`,
            variant.quantity,
          );
          console.log(variant);
          variant?.values?.forEach((val, valIndex) => {
            console.log(val);
            formData2.append(
              `variants[${index + 1}][values][${valIndex + 1}]`,
              val,
            );
          });
        });

      console.log("API Request Data:", formData2);

      dispatch(createProductService(formData2)).then((response) => {
        console.log(response);
        if (response?.payload?.status == 200) {
          //  alert("good");
          toast.success(t("product_added_success"));
          dispatch(getAllProductsService({ page: 1 }));
        } else {
          console.log(response);
          Object.values(response.payload.errors)
            .flatMap((errorArray) => errorArray)
            .forEach((error) => toast.warn(error));
        }
      });
    } catch (error) {
      console.log(error);
      alert("cat");
      const errors = error?.response?.data?.errors;
      if (errors && typeof errors === "object") {
        // استخراج كل مصفوفات الرسائل ودمجها في مصفوفة واحدة
        const allErrors = Object.values(errors).flat();
        allErrors.forEach((msg) => toast.warn(msg));
      } else {
        toast.error(t("generalError"));
      }
    } finally {
      setLoading(false);
    }
  };
  const handleHasAttributesChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      hasAttributes: value,
      // إذا أصبح false، امسح الـ attributes إذا تبي (اختياري)
      ...(value ? {} : { attributes: [] }),
    }));
  };
  const handleSetQuantity = (value) => {
    setFormData((prev) => ({
      ...prev,
      quantity: value, // حدث الكمية (string أو number)
    }));
  };
  useEffect(() => {
    dispatch(getAllCategoriesService({ page: 1 }));
  }, [dispatch]);

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">{t("add_product_title")}</h1>

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Basic Information Section */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-4">
            {t("basic_information")}
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label
                htmlFor="category"
                className="block text-sm font-semibold text-gray-800 mb-2"
              >
                {t("category_label")}
              </label>
              {/*<Select
                name="category_id"
                value={formData.category_id}
                onChange={(value) => {
                  dispatch(getSubCategorieByCategoryService(value));
                  handleInputChange("category_id", value);
                }}
                options={categoryList.map((category) => ({
                  value: category.id,
                  label: category?.translations?.ar?.name,
                }))}
                placeholder={t("select_category_placeholder")}
                required
              />*/}

              <Select
                name="category_id"
                value={formData.category_ids}
                onChange={(value) => {
                  console.log(value);
                  const params = { category_ids: value };

                  dispatch(getSubCategorieByCategoryService(params));

                  handleInputChange("category_ids", value);
                }}
                options={categoryList.map((category) => ({
                  value: category.id,
                  label: category?.translations?.ar?.name,
                }))}
                placeholder={t("select_category_placeholder")}
                multiple={true} // إضافة multiple={true} لجعله multi select
                required
              />
            </div>

            <div>
              <label
                htmlFor="category"
                className="block text-sm font-semibold text-gray-800 mb-2"
              >
                {t("subCategoriesOf")}
              </label>
              <Select
                name="subcategory_id"
                value={formData.subcategory_id}
                onChange={(value) => handleInputChange("subcategory_id", value)}
                options={subCategories.map((category) => ({
                  value: category.id,
                  label: category?.translations?.ar?.name,
                }))}
                placeholder={t("select_subcategory_placeholder")}
                multiple={true} 
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                {" "}
                {t("price_label")}
              </label>
              <input
                type="number"
                value={formData.price}
                onChange={(e) => handleInputChange("price", e.target.value)}
                className="w-full px-3 py-2 border rounded"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                {t("price_after_discount_label")}
              </label>
              <input
                type="number"
                value={formData.price_after_discount}
                onChange={(e) =>
                  handleInputChange("price_after_discount", e.target.value)
                }
                className="w-full px-3 py-2 border rounded"
              />
            </div>

            <div className="flex items-center">
              <input
                type="checkbox"
                id="is_special"
                checked={formData.is_special}
                onChange={(e) =>
                  handleInputChange("is_special", e.target.checked)
                }
                className="mr-2"
              />
              <label htmlFor="is_special" className="text-sm font-medium">
                {t("is_special_label")}
              </label>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
            {/*    <div>
              <label className="block text-sm font-medium mb-1">
                {t("product_name_en")}
              </label>
              <input
                type="text"
                value={formData.translations.en.name}
                onChange={(e) =>
                  handleInputChange("translations.en.name", e.target.value)
                }
                className="w-full px-3 py-2 border rounded"
                required
              />
            </div>*/}

            <div>
              <label className="block text-sm font-medium mb-1">
                {t("product_name_ar")}
              </label>
              <input
                type="text"
                value={formData.translations.ar.name}
                onChange={(e) =>
                  handleInputChange("translations.ar.name", e.target.value)
                }
                className="w-full px-3 py-2 border rounded"
                required
              />
            </div>

            {/* <div>
              <label className="block text-sm font-medium mb-1">
                {t("description_en")}
              </label>
              <textarea
                value={formData.translations.en.desc}
                onChange={(e) =>
                  handleInputChange("translations.en.desc", e.target.value)
                }
                className="w-full px-3 py-2 border rounded"
                rows={3}
              />
            </div>*/}

            <div>
              <label className="block text-sm font-medium mb-1">
                {t("description_ar")}
              </label>
              <textarea
                value={formData.translations.ar.desc}
                onChange={(e) =>
                  handleInputChange("translations.ar.desc", e.target.value)
                }
                className="w-full px-3 py-2 border rounded"
                rows={3}
              />
            </div>
          </div>
        </div>

        {/* Product Images Section */}
        <ProductImageUpload
          images={formData.images}
          onChange={(images) => handleInputChange("images", images)}
        />

        {/* Attributes Section */}
        <AttributeSection
          attributes={formData.attributes}
          onAddAttribute={handleAddAttribute}
          hasAttributes={formData.hasAttributes} // جديد
          onHasAttributesChange={handleHasAttributesChange} // جديد
          quantity={formData.quantity} // جديد
          onSetQuantity={handleSetQuantity} // موجود، بس دلوقتي يحدث الـ input
        />

        {/* Variants Section */}
        <VariantSection
          variants={formData.variants}
          attributes={formData.attributes}
          onAddVariant={handleAddVariant}
        />

        {/* Form Actions */}
        <div className="flex justify-end space-x-4">
          <button
            type="button"
            onClick={() => setIsAddProduct(false)}
            className="mr-2 ml-2 px-4 py-2 border rounded hover:bg-gray-100"
          >
            {t("cancel_button")}
          </button>
          <Button
            type="submit"
            disabled={isLoadingAction}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-blue-400"
          >
            {isLoadingAction ? t("saving_button") : t("save_button")}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddProduct;
